/**
 * FNV-1a 32-bit hash — fast, deterministic, and works in both Node and browser.
 * Used to key pre-baked translation entries on the quote document.
 */
export function contentHash(str: string): string {
  let hash = 2166136261 // FNV offset basis (32-bit)
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i)
    hash = Math.imul(hash, 16777619) >>> 0 // FNV prime, keep as uint32
  }
  return hash.toString(36)
}
